import React from "react";
import { mdiFileDocument, mdiGraph, mdiImage, mdiLicense, mdiSvg } from "@mdi/js";
import { ControlButton } from "reactflow";
import Icon from "@mdi/react";
import { toPng, toSvg } from "html-to-image";
import { useReactFlow } from "reactflow";

export function ResetLayoutControl({ onResetLayout }) {
  return (
    <ControlButton>
      <Icon path={mdiGraph} onClick={onResetLayout}></Icon>
    </ControlButton>
  );
}

export function LicenseControl() {
  return (
    <ControlButton>
      <Icon
        path={mdiLicense}
        onClick={() =>
          window.open("NOTICE.txt", "_blank", "noopener, noreferrer")
        }
      ></Icon>
    </ControlButton>
  );
}

export function ImageDownloadControl({ onResetLayout }) {
  const reactFlowInstance = useReactFlow();

  const downloadImage = (dataUrl) => {
    const a = document.createElement("a");

    a.setAttribute("download", "playbook.png");
    a.setAttribute("href", dataUrl);
    a.click();
  };
  const onClicked = () => {
    reactFlowInstance.fitView();
    onResetLayout();
    toPng(document.querySelector(".react-flow"), {
      style: {
        transform: "translate(0, 0) scale(1)",
      },
      filter: (node) => {
        if (
          node?.classList?.contains("react-flow__minimap") ||
          node?.classList?.contains("react-flow__controls") ||
          node?.classList?.contains("react-flow__attribution") ||
          node?.classList?.contains("playbookInfoCard")
        ) {
          return false;
        }

        return true;
      },
    }).then(downloadImage);
  };

  return (
    <ControlButton>
      <Icon path={mdiImage} onClick={onClicked}></Icon>
    </ControlButton>
  );
}

export function VectorGraphicDownloadControl({ onResetLayout }) {
  const reactFlowInstance = useReactFlow();

  const downloadImage = (dataUrl) => {
    const a = document.createElement("a");

    a.setAttribute("download", "playbook.svg");
    a.setAttribute("href", dataUrl);
    a.click();
  };
  const onClicked = () => {
    reactFlowInstance.fitView();
    onResetLayout();
    toSvg(document.querySelector(".react-flow"), {
      style: {
        transform: "translate(0, 0) scale(1)",
      },
      filter: (node) => {
        if (
          node?.classList?.contains("react-flow__minimap") ||
          node?.classList?.contains("react-flow__controls") ||
          node?.classList?.contains("react-flow__attribution") ||
          node?.classList?.contains("playbookInfoCard")
        ) {
          return false;
        }

        return true;
      },
    }).then(downloadImage);
  };

  return (
    <ControlButton>
      <Icon path={mdiSvg} onClick={onClicked}></Icon>
    </ControlButton>
  );
}

export function DocumentDownloadControl({ onResetLayout }) {
  const reactFlowInstance = useReactFlow();

  const exportAsDocument = async () => {
    reactFlowInstance.fitView();
    onResetLayout();
    toSvg(document.querySelector(".react-flow"), {
      style: {
        transform: "translate(0, 0) scale(1)",
      },
      filter: (node) => {
        if (
          node?.classList?.contains("react-flow__minimap") ||
          node?.classList?.contains("react-flow__controls") ||
          node?.classList?.contains("react-flow__attribution") ||
          node?.classList?.contains("playbookInfoCard")
        ) {
          return false;
        }

        return true;
      },
    }).then(async (svgContent) => {
      const svgElement = await decodeURIComponent(
        svgContent.replace("data:image/svg+xml;charset=utf-8,", "'").trim()
      );
      const newWindow = window.open();
      const width = "100%"
      const height = "100%"
      newWindow.document.write(
        `<html>
          <head>
          <title>playbook.pdf</title>
          <style>
                            body {
                              width: ${width};
                              height: ${height};
                              margin: auto
                            }
                            .container {
                                background: #121212;
                                text-align: center;
                                height: 100%;
                                width: 100%;
                            }
                            
                            @page {
                              size: A4 landscape !important;
                              margin:0 !important;
                            }
                            @media print {
                                * {
                                  
                                    -webkit-print-color-adjust: exact !important;
                                    color-adjust: exact !important;
                                    print-color-adjust: exact !important;
                                }
                                .container {
                                    background: #121212;
                                }
                            }
                        </style>
          </head>
          <body>
          <div class='container'>
              <div class='svg-container'>
                  ${svgElement}
              </div>
              
              <script>
                  document.close();
                  window.print();
              </script>
          </div>
      </body>

          </html>`
      );
    });
  };

  return (
    <ControlButton>
      <Icon path={mdiFileDocument} onClick={exportAsDocument}></Icon>
    </ControlButton>
  );
}
